import { Routes, Route } from "react-router-dom";
import InvestigatorsList from "./InvestigatorsList";
import InvestigatorForm from "./InvestigatorForm";
import InvestigatorDetail from "./InvestigatorDetail";

export default function InvestigatorsRoutes() {
  return (
    <Routes>
      <Route index element={<InvestigatorsList />} />
      <Route path="new" element={<InvestigatorForm />} />
      <Route path=":id/edit" element={<InvestigatorForm />} />
      <Route path=":id" element={<InvestigatorDetail />} />
    </Routes>
  );
}
